<script>
  import lodash from 'lodash';
  import ByPersonTrendChart from './ByPersonTrendChart.vue';

  export default {
    name: 'NetMarginTrends',
    extends: ByPersonTrendChart,
    data() {
      return {
        chartId: 'netMarginTrends',
        propertyName: 'ha_gross_profit',
        propertyNamePerson: 'net_hearing_aid_revenue',
        label: 'Net Margin',
        curYearColor: '#998CE3',
        prevYearColor: '#6AEDC7',
      };
    },
    computed: {
      benchmark() {
        return {
          kpi_name: this.propertyName,
          low_value_monthly: (this.numPerPerson.low_value_monthly || 0) * (this.grossMarginPercent.low_value_monthly || 0) * this.avgNumPersons,
          median_value_monthly: (this.numPerPerson.median_value_monthly || 0) * (this.grossMarginPercent.median_value_monthly || 0) * this.avgNumPersons,
          high_value_monthly: (this.numPerPerson.high_value_monthly || 0) * (this.grossMarginPercent.high_value_monthly || 0) * this.avgNumPersons,
        };
      },
      grossMarginPercent() {
        return lodash.find(this.benchmarks, ['kpi_name', 'gross_margin_per_net_ha_rev']);
      },
    }
  };
</script>
